import { ITableViewResponse, ITableViewsBody, ITableViewsResponse, UpdateTableView } from "../interfaces/table-view";
import authBaseAxios from "../utils/api";

export const TableViewServices = {
  getCustomView: (tableName: string): Promise<ITableViewResponse> => {
    return authBaseAxios.get(`custom-views/${tableName}`);
  },
  updateCustomView: (tableName: string, data: UpdateTableView): Promise<ITableViewResponse> => {
    return authBaseAxios.post(`custom-views/${tableName}`, data);
  },
  getTableViews: (tableName: string): Promise<ITableViewsResponse> => {
    return authBaseAxios.get(`table-views/${tableName}/views`);
  },
  createTableViews: (body: ITableViewsBody): Promise<any> => {
    return authBaseAxios.post(`table-views/`, body);
  },

  setCurrentView: (viewId: string,tableName: string): Promise<any> => {
    return authBaseAxios.post(`/table-views/${tableName}/set-current-view`, {viewId: viewId});
  },

  updateTableViews: (viewId: string,body: ITableViewsBody): Promise<any> => {
    return authBaseAxios.put(`/table-views/${viewId}`, body);
  },

  exitTableViews: (viewId: string): Promise<any> => {
    return authBaseAxios.get(`/table-views/${viewId}/exit`);
  },

  deleteTableViews: (viewId: string): Promise<any> => {
    return authBaseAxios.delete(`/table-views/${viewId}`);
  },
};
